export const labels = {
	leave: {
		label: "Label.MobileCreator.LeaveDialog.LeaveEditor",
		default: "Leave editor",
	},
	backToProduct: {
		label: "Label.MobileCreator.LeaveDialog.BackToProduct",
		default: "Back to product",
	},
	title: {
		label: "Label.MobileCreator.LeaveDialog.Title",
		default: "You have unsaved changes",
	},
	message: {
		label: "Label.MobileCreator.LeaveDialog.Message",
		default: "Are you sure you want to leave the editor?",
	},
};
